import { render, staticRenderFns } from "./MapList.vue?vue&type=template&id=5c4e95d5&scoped=true"
import script from "./MapList.vue?vue&type=script&lang=ts"
export * from "./MapList.vue?vue&type=script&lang=ts"
import style0 from "./MapList.vue?vue&type=style&index=0&id=5c4e95d5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4e95d5",
  null
  
)

export default component.exports